import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation } from "swiper";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// components
import BlogItem from "src/components/Blog/BlogItem/BlogItem";
import { Heading } from "src/components";

// mockup
import mockup from "src/utils/data";

// api
import { getBlogList } from "src/components/Blog/api";

SwiperCore.use([Pagination, Navigation]);

const CarouselNew = () => {
  const [blogList, setBlogList] = useState(mockup.empty_3);

  useEffect(() => {
    getBlogList()
      .then((res) => {
        if (res.data.Status) {
          setBlogList(res.data.Results.filter((item) => item.BlogId !== 3));
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  return (
    <div className={`carousel--new ${styles.carousel__wrapper}`}>
      <div className={styles.container}>
        <div className={styles.heading__wrapper}>
          <Heading heading="More good reads" link="/blogs" />
        </div>
        <Swiper
          spaceBetween={16}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={true}
          centeredSlides={true}
          freeMode={true}
          preloadImages
          pagination={{ clickable: true }}
          breakpoints={{
            576: {
              slidesPerView: "auto",
              spaceBetween: 30,
              freeMode: false,
            },
          }}
        >
          {" "}
          {blogList.map((item, i) => (
            <SwiperSlide key={i}>
              <BlogItem data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CarouselNew;
